<script lang="ts" setup>
import { ElFormItem, ElInput } from "element-plus";
import { computed, ref, watch } from "vue";
import { useValidation } from "@/composables/validation";
import { useI18n } from "vue-i18n";

export interface Props {
  modelValue?: string;
  disabled: boolean;
  required?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: "update:model-value", value: string): void;
}>();

const { validateEmail, validateRequiredField, validateFormItem } =
  useValidation();
const { locale } = useI18n();

const input = ref<string>(props.modelValue ?? "");
const formItemRef = ref<InstanceType<typeof ElFormItem> | null>(null);

const rules = computed(() =>
  props.required
    ? [validateRequiredField(input), validateEmail(input)]
    : [validateEmail(input)]
);

watch(
  () => props.modelValue,
  (value) => (input.value = value ?? "")
);

watch(locale, () => {
  const fieldRefs = { formItemRef: formItemRef.value };
  validateFormItem(fieldRefs);
});
</script>

<template>
  <el-form-item
    ref="formItemRef"
    prop="email"
    :rules="rules"
    :required="required"
  >
    <template #label>
      <slot name="label" />
    </template>
    <el-input
      v-model="input"
      :disabled="disabled"
      @input="emit('update:model-value', $event)"
    />
  </el-form-item>
</template>
